export default {"src":"/_next/static/media/deco_checkout_mastercard.e4c03d65.svg","height":34,"width":43,"blurWidth":0,"blurHeight":0};